import React from 'react';
import {
    Box,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemSecondaryAction,
    ListItemText,
} from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import GetAppIcon from '@material-ui/icons/GetApp';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { useTranslate } from 'react-admin';
import NoteItemCollapse from './NoteItemCollapse';

interface DocumentItem {
    urlToDownload: string;
    name: string;
}

interface Props {
    documents: DocumentItem[];
}

export const removeNamePrefix = (name: string) => {
    const split = name.split('*_*');
    return split.length > 1 ? split[1] : split[0];
};

const ShowNoteDocuments: React.FC<Props> = ({ documents }) => {
    const t = useTranslate();
    if (!documents || documents.length === 0) return null;

    const openFile = (url: string) => window.open(url, '_blank');

    return (
        <NoteItemCollapse title={t('app.objects.documents')} icon={<AttachFileIcon />}>
            <Box style={{ display: 'grid', gap: 8, paddingLeft: 16, paddingRight: 16 }}>
                <List style={{ padding: 0 }}>
                    {documents.map(({ urlToDownload, name }) => (
                        <ListItem key={urlToDownload}>
                            <ListItemIcon style={{ minWidth: 40 }}>
                                <PictureAsPdfIcon />
                            </ListItemIcon>
                            <ListItemText primary={removeNamePrefix(name)} />
                            <ListItemSecondaryAction>
                                <IconButton edge='end' onClick={() => openFile(urlToDownload)}>
                                    <GetAppIcon />
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                    ))}
                </List>
            </Box>
        </NoteItemCollapse>
    );
};

export default ShowNoteDocuments;
